import { FC } from 'react';
import { useRoutes } from 'react-router-dom';
import { i18nNsFactory } from '@atlas-frontend/i18n';
import { onBasePath } from '../../paths/onBasePath';
import { path } from '../../paths';
import translations from './InputData.translations.json';
import { NotFound } from '../NotFound';
import { InputDataProcessingEventReport } from './processingEvents/InputDataProcessingEventReport';
import { InputDataProcessingEventsDirectory } from './processingEvents/InputDataProcessingEventsDirectory';
import { InputDataDetailWithContext } from './sample/InputDataDetail';
import { InputDataDirectory } from './InputDataDirectory';
import { InputDataSubjectDetail } from './details/InputDataSubjectDetail';

export const { addTranslations, Translation } =
  i18nNsFactory('input-data-page');
addTranslations(translations);

export const INPUT_DATA_ROUTES = [
  {
    path: path.inputDataDirectory,
    renderBreadcrumb: () => (
      <Translation>{(t) => t('breadcrumb.input-data')}</Translation>
    ),
    children: [
      {
        index: true,
        element: <InputDataDirectory />,
      },
      {
        path: path.inputDataErrorDirectory,
        element: <InputDataProcessingEventsDirectory />,
      },
      {
        path: path.inputDataErrorReport,
        element: <InputDataProcessingEventReport />,
      },
      {
        path: path.inputDataDetails,
        element: <InputDataSubjectDetail />,
        renderBreadcrumb: (data?: string) => data,
      },
      {
        path: path.inputDataView,
        element: <InputDataDetailWithContext />,
        renderBreadcrumb: (data?: string) => data,
      },
    ],
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export const InputData: FC<{ basePath: string }> = ({ basePath }) =>
  useRoutes(onBasePath(basePath, INPUT_DATA_ROUTES));
